<template>
  <div :class="['handsg-header', {'is-flag': $flag}, {'is-scrolled': isScrolled}]">
    <div class="web-header">
      <div class="header-container">
        <a href="/" class="logo-alink">
          <img class="logo-img" src="./assets/images/logo.png" @click="handleSkipToHome" />
        </a>
        
        <div v-if="!$flag" class="menu-pannel">
          <div class="menu-li" v-for="(menu, index) in menuList" :key="index" @click="handleSkipToPage(menu, index)">
            <span class="name-text" :class="{ 'active-name': activeIndex === index }">{{ menu.name }}</span>
            <div class="li-active-line" :class="{ 'is-active': activeIndex === index }"></div>
          </div>
        </div>

        <div v-else class="mobile-toggle" @click="show = !show">
          <i :class="show ? 'el-icon-close' : 'el-icon-menu'"></i>
        </div>
      </div>
    </div>

    <transition name="el-fade-in">
      <div v-show="show" class="mobile-menu-overlay" @click="show = false">
        <div class="mobile-menu" @click.stop>
          <div v-for="(menu, index) in menuList" :key="index" class="mobile-menu-item" :class="{ 'active': activeIndex === index }" @click="handleSkipToPage(menu, index)">
            {{ menu.name }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HeaderItem',
  data() {
    return {
      show: false,
      isScrolled: false,
      menuList: [
        { name: '网站首页', url: '/' },
        { name: '关于我们', url: '/AboutUs' },
        { name: '产品中心', url: '/ProductCenter' },
        { name: '联系我们', url: '/ContactUs' }
      ],
      activeIndex: 0
    }
  },
  watch: {
    '$route.path': {
      handler(val) {
        this.activeIndex = this.menuList.findIndex((item) => item.url === val);
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    handleSkipToPage(menu, index) {
      this.activeIndex = index;
      if (this.$route.path !== menu.url) {
        this.$router.push({ path: menu.url });
      }
      this.show = false;
    },
    handleSkipToHome() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    }
  }
};
</script>

<style lang="less">
@import './assets/css/index.less';
</style>
